<template>
    <ul class="dot-list details-list text-left">
        <li v-for="(item, index) in items" :key="'item' + index">
            <slot :item="item" :index="index">
                <div v-html="item" class="dot-list__item"></div>
            </slot>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'DotList',
    props: {
        items: {
            type: Array,
            require: true
        }
    }
};
</script>

<style scoped lang="scss">
@use '@/styles/mixins';

ul.dot-list {
    li {
        position: relative;

        &::before {
            content: '•';
            position: absolute;
            left: 0.2em;
        }
    }

    &__item {
        word-wrap: break-word; //to prevent mobile horizontal bar caused by too long text
    }
}
</style>
